var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row living-options"},[_c('card-tabs',{staticClass:"col-12 w-100",attrs:{"tabs":[{
      active: _vm.projectConfig.nowSelling.livingOption.active,
      label: ((_vm.projectConfig.nowSelling.livingOption.label) + "s"),
      id: 'masterplan',
    }, {
      active: _vm.projectConfig.nowSelling.subsectionGroup.active,
      label: ((_vm.projectConfig.nowSelling.subsectionGroup.label) + "s"),
      id: 'subsectionGroups',
    },{ 
      active: _vm.projectConfig.nowSelling.subsectionGroup.active,
      label: ((_vm.projectConfig.nowSelling.subsection.label) + "s"),
      id: 'subsections',
    },{
      active: _vm.projectConfig.nowSelling.subsectionGroup.active,
      label: ((_vm.projectConfig.nowSelling.property.label) + "s"),
      id: 'properties',
    },{
      active: _vm.projectConfig.nowSelling.subsectionGroup.active,
      label: ((_vm.projectConfig.nowSelling.dwelling.label) + "s"),
      id: 'dwellings',
    },{
      active: _vm.projectConfig.nowSelling.package.active,
      label: ((_vm.projectConfig.nowSelling.package.label) + "s"),
      id: 'packages',
    }],"active-tab":_vm.activeTab},on:{"tabClick":_vm.navigateToTab},scopedSlots:_vm._u([{key:"masterplan",fn:function(){return [_c('LivingOptionsMasterplan')]},proxy:true},{key:"subsectionGroups",fn:function(){return [_c('LivingOptionsSubsectionGroups')]},proxy:true},{key:"subsections",fn:function(){return [_c('LivingOptionsSubsections')]},proxy:true},{key:"properties",fn:function(){return [_c('LivingOptionsProperties')]},proxy:true},{key:"dwellings",fn:function(){return [_c('LivingOptionsDwellings')]},proxy:true},{key:"packages",fn:function(){return [_c('LivingOptionsPackages')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }